"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupType = void 0;
var PopupType;
(function (PopupType) {
    PopupType["AgeVerifier"] = "age";
    PopupType["Promo"] = "promo";
    PopupType["Signup"] = "signup";
})(PopupType || (exports.PopupType = PopupType = {}));
